import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupCompanyReportsList } from '@shared/api/lib/group/group';
import {
  GroupCompanyReportsListParams,
  PaginatedGroupCompanyReportListList,
} from '@shared/api/types';

/**
 * Paginated company reports across the parent's selected child organizations.
 * Filters by `orgs` and an end-date window via `start`/`end`.
 */
export const useGetGroupCompanyReports = (
  params?: GroupCompanyReportsListParams
) =>
  useGroupCompanyReportsList<PaginatedGroupCompanyReportListList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });
